import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { GatsbyImg } from '.';
import { H3 } from './rebrand/Typography';

type CTAProps = {
  className?: string;
  children: React.ReactNode;
  image: any;
  imgAltText?: string;
  title: string;
};

export const CTA: React.FC<CTAProps> = ({ className, children, image, imgAltText, title }) => {
  return (
    <div className={twMerge(clsx('rounded-16 bg-primary-50', className))}>
      <div className="flex flex-wrap md:flex-nowrap">
        <div className="h-200 w-full flex-shrink-0 overflow-hidden rounded-l-16 bg-primary-500 object-cover xs:h-260 md:h-[unset] md:w-1/3">
          <GatsbyImg image={image} className="h-full w-full" alt={imgAltText} objectFit="cover" />
        </div>
        <div className="flex w-full flex-1 flex-col items-center justify-center p-32 md:w-auto md:items-start">
          <H3 className="mb-12 text-2xl leading-tight text-primary-350 md:text-2xl">{title}</H3>
          {children}
        </div>
      </div>
    </div>
  );
};
